import custom from 'shared/styles/custom.styles'

const styles = () => {
    return { dialogRoot: custom.boxShadowRadius }
}

export default styles
